import React, { useEffect, useState } from "react";
import "./styles/DashboardHome.css";
import {
  Dot,
  PrimaryBtn,
  SectionHeading1,
} from "../../components/BasicComponents";
import { useTranslation, Trans } from "react-i18next";
import instance from "../../axios";
import { createPortal } from "react-dom";
import { getUserToken, setUserToken } from "../../utils/userAuthenticate";
import Spinner from "../../components/Loaders/Spinner";
import StarFull from "../../assets/icons/pngs/Star.png";
import StarNull from "../../assets/icons/pngs/StarNull.png";
import Toast from "../../components/Toast";
import useScrollTop from "../../hooks/useScrollTop";
import useUserAuthentication from "../../hooks/useUserAuthentication";

import { Link } from "react-router-dom";
import "../../localisation/index";
const DashboardHome = () => {
  const appReviewUrl = process.env.REACT_APP_REVIEW_URL
  const appName = process.env.REACT_APP_NAME
  const {t, i18nKey} = useTranslation()
  useUserAuthentication();
  useScrollTop();

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);
  const [kycData, setKycData] = useState(null);


  const getKycStatus = async () => {
    const url = "/kyc/status";
    const headers = {
      Authorization: getUserToken(),
    };

    try {
      const res = await instance.post(url, {}, { headers });

      if (res?.status === 200) {
        const resData = res.data;

        if (resData?.code === 401) {
          throw new Error(t("errors.authenticationError"));
        }
        if (resData?.code === 403) {
          throw new Error(t("errors.sessionError"));
        }

        // for any other error
        if (resData?.code !== 200) {
          throw new Error(t("errors.serverError"));
        }
        // console.log(resData);
        setKycData(resData.data);
        sessionStorage.setItem("qcUserEmail", resData?.data?.email);
        sessionStorage.setItem("qcStoreCurrencyCode", resData?.data?.currency)
      }
    } catch (error) {
      // console.log(error);
      setIsError(error.message);
    }
  };

  const handleKYC = async () => {
    setIsLoading(true);
    const url = "/kyc/initiate";
    const headers = {
      Authorization: getUserToken(),
    };

    try {
      const res = await instance.post(url, {}, { headers });

      const resData = res.data;

      window.open(resData.data, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getKycStatus();
  }, []);

  if (isError) {
    return <Toast>{isError}</Toast>;
  }
  else if(kycData && !kycData.kyc){
    return (
      <div className="dashboard-pending-kyc">
          <img src={require("../../assets/images/Website Profile Dark.png")} alt="" />
          <p><Trans i18nKey="dashboardHome.description1" values={{appName}} components={{ b: <strong /> }} /></p>
          <p>{t("dashboardHome.description2")}</p>
          <p><Trans i18nKey="dashboardHome.description3" components={{b: <b />}} /></p>
      </div>
    )
  }else if(kycData && !kycData.payment){
    return (
        <div className="dashboard-pending-payment">
            <img src={require("../../assets/images/payment.jpg")} alt="" />
            <Trans i18nKey="dashboardHome.description4" values={{appName}} components={{b: <p />}} />
            <Link to={"/select-plan"}>
              <button className="select-plan-button" >
                {t("dashboardHome.proceed")}
              </button>
            </Link>
        </div>
    )
  }
  return (
    <div className="dashboard-home-container component">
      {isLoading &&
        createPortal(<Spinner />, document.getElementById("portal"))}

      <div className="component-primary-heading">{t("dashboardHome.welcome")}</div>

      <div className="section-box-container">
        <h3 className="title home-title">{t("dashboardHome.congrats", {appName})}</h3>
      </div>
      <div className="section-box-container">
        <a href={appReviewUrl}>
          <p className="section-para">{t("dashboardHome.rating")}</p>
          <div className="rating-stars">
            <img src={StarFull} alt="" />
            <img src={StarFull} alt="" />
            <img src={StarFull} alt="" />
            <img src={StarFull} alt="" />
            <img src={StarNull} alt="" />
          </div>
        </a>
      </div>

      {/* <img src={Giftbox} alt="" className="giftbox" />   */}
    </div>
  );
};

export default DashboardHome;
